import useStyles from "./styles";
import {
  Avatar,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography
} from "@material-ui/core";
import { Article, Celebration } from "@mui/icons-material";
import { Business } from "@material-ui/icons";
import StoreIcon from "@material-ui/icons/Store";
import React from "react";
import { useI18n } from "../../../../hooks/useI18n";

export interface WelcomeProps {
  onClick: () => void;
}

export const Welcome = ({ onClick }: WelcomeProps) => {
  const classes = useStyles();
  const { t } = useI18n();

  return (
    <>
      <Avatar className={classes.bigAvatar}>
        <Celebration className={classes.onBoardingIcon} />
      </Avatar>
      <Typography variant={"h4"}>{t("common.welcome")}</Typography>
      <Typography className={classes.onBoardingTitle} variant={"subtitle1"}>
        {t("common.beforeYouCanStartSelling")}
      </Typography>
      <List>
        <ListItem>
          <ListItemIcon>
            <Business fontSize={"large"} />
          </ListItemIcon>
          <ListItemText
            primary={t("common.updateYourCompanyInformation")}
            secondary={t("common.organizationalNumberBankDetails")}
          />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <StoreIcon fontSize={"large"} />
          </ListItemIcon>
          <ListItemText
            primary={t("common.updateYourStoreDetails")}
            secondary={t("common.streetPostalCodeCity")}
          />
        </ListItem>
        {/*        <ListItem>
          <ListItemIcon>
            <Article fontSize={"large"} />
          </ListItemIcon>
          <ListItemText
            primary={t("common.uploadYourProducts")}
            secondary={
              t("common.uploadExcelFileWithProducts")
            }
          />
        </ListItem>*/}
      </List>
      <Button
        className={classes.onBoardingButton}
        variant="contained"
        color="primary"
        onClick={onClick}
      >
        {t("common.getGoing")}
      </Button>
    </>
  );
};
